module.exports = __webpack_public_path__ + "static/media/pg-200-switches.84eb0593.png";